import { Avatar } from 'module/ui/components/atoms/avatar';
import { HeadingCompact01, Short00 } from 'module/ui/components/styles';
import {
  AccountPeopleProfile,
  UserExperience,
} from 'api/account-people/profile-type';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Collapsible, EmptyContent } from './collapsible-section';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
`;

const ExperienceItem = styled.div`
  display: flex;
  gap: var(--spacing-03);
`;
const Role = styled.div`
  ${HeadingCompact01};
`;
const Company = styled.div`
  ${Short00};
`;
const Timeline = styled.div`
  ${Short00};
  color: var(--text-tertiary);
`;
const ExperienceItemContent = styled.div`
  display: flex;
  flex-direction: column;
  ${Company} {
    margin-top: var(--spacing-01);
  }
  ${Timeline} {
    margin-top: var(--spacing-02);
  }
`;
const getStartAndEnd = (experience: UserExperience) => {
  const isPresent = experience.endDate == null;
  const start = moment(experience.startDate).format('YYYY');
  const end = isPresent
    ? moment().format('YYYY')
    : moment(experience.endDate).format('YYYY');

  if (start === end) {
    return {
      start: moment(experience.startDate).format('MMM YYYY'),
      end: isPresent ? null : moment(experience.endDate).format('MMM YYYY'),
    };
  }

  return {
    start,
    end: isPresent ? null : end,
  };
};

interface Props {
  userProfile: AccountPeopleProfile;
}
export const Experience: React.FC<Props> = ({ userProfile }) => {
  const isEmpty =
    (userProfile.userProfile?.enrichedUserData?.userExperience?.length ?? 0) ===
    0;

  return (
    <Collapsible
      title={
        <FormattedMessage id="account.people.profile.sections.experience.title" />
      }
      panelKey="experience"
    >
      {isEmpty ? (
        <EmptyContent>
          <FormattedMessage id="account.people.profile.sections.experience.empty" />
        </EmptyContent>
      ) : (
        <Wrapper>
          {userProfile.userProfile?.enrichedUserData?.userExperience?.map(
            (experience) => {
              const { start, end } = getStartAndEnd(experience);

              return (
                <ExperienceItem key={experience.company.companyName}>
                  <Avatar
                    src={experience.company.companyLogoUrl}
                    name={experience.company.companyName}
                    size={32}
                    shape="square"
                  />
                  <ExperienceItemContent>
                    <Role>{experience.role}</Role>
                    <Company>{experience.company.companyName}</Company>
                    <Timeline>
                      {start} -{' '}
                      {end ? (
                        end
                      ) : (
                        <FormattedMessage id="account.people.profile.sections.experience.present" />
                      )}
                    </Timeline>
                  </ExperienceItemContent>
                </ExperienceItem>
              );
            },
          )}
        </Wrapper>
      )}
    </Collapsible>
  );
};
